export const AddIcon: React.FC<React.SVGAttributes<{}>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    {...props}
  >
    <circle
      cx="11.4932"
      cy="11.2357"
      r="9.97857"
      stroke="#197FDB"
      strokeWidth="1.81429"
    />
    <line
      x1="11.4941"
      y1="6.70001"
      x2="11.4941"
      y2="15.7714"
      stroke="#197FDB"
      strokeWidth="1.81429"
    />
    <line
      x1="16.0283"
      y1="11.2357"
      x2="6.95689"
      y2="11.2357"
      stroke="#197FDB"
      strokeWidth="1.81429"
    />
  </svg>
);
